jQuery(window).bind('resize load', ( evt ) => {

	if( typeof jQuery.equalHeight == 'function' ) {
		jQuery('.linkbox-title', '.linkbox.linkbox--persona').equalHeight();
		jQuery('.linkbox.linkbox--persona').equalHeight();
	}


	jQuery('[data-toggle="company_type"]', '.companylist').on('click', function () {
		let that = jQuery(this),
			termId = that.data('termid'),
			parent = that.closest('.companylist');

		parent.find('.companylist-item').show();

		if ( !that.hasClass('is-active') ) {
			parent.find('.companylist-item:not([data-terms*="' + termId + '"])').hide();
			jQuery('[data-toggle="company_type"].is-active', '.companylist').removeClass('is-active');
		}
		else {

		}
		that.toggleClass('is-active');

	});

	function showMap() {
		jQuery('iframe.google_map').each(function () {
			jQuery(this).attr('src', jQuery(this).attr('data-src'));
		});
		jQuery('button[data-action="showmap"]').parent().remove();
	}

	jQuery('[data-action="showmap"]').on('click', function () {
		let d = new Date();
		window.localStorage.setItem('showMap', d.getTime() );

		showMap();

	});
	if ( window.localStorage.getItem('showMap') !== null ) {
		showMap();
	}
});